const getPdpUrl = (productSlug: string|undefined, variantSku: string|undefined, variantColour: string|undefined) => {
    productSlug = productSlug?.replace(/-[^-]+$/,'') ?? '';
    variantColour = variantColour?.replace(/[\s\\/]+/g, '-').toLowerCase() ?? '';
    if(variantColour)
        return `/product/${productSlug}-${variantColour}-${variantSku}/`;
    else
        return `/product/${productSlug}-${variantSku}/`;
}

const getPdpUrlWithLocale = (locale: string, productSlug:  string|undefined, variantSku:  string|undefined, variantColour:  string|undefined) => {
    return `/${locale}${getPdpUrl(productSlug, variantSku, variantColour)}`;
}

const isPdpUrl = (urlOrSlug: string) => {
    const cleanUrl = urlOrSlug.split('?')[0]; // Remove query string
    return cleanUrl.indexOf('/product/') != -1 || cleanUrl.startsWith('product/');
}

/*
Handle all following string formats with or without trailing '/', wit or without a query string
https://caroma.com/au/product/urbane-ii-hand-shower-chrome-105964/
/au/product/urbane-ii-hand-shower-chrome-105964/
au/product/urbane-ii-hand-shower-chrome-105964/
/product/urbane-ii-hand-shower-chrome-105964/
product/urbane-ii-hand-shower-chrome-105964/
*/
const getSkuFromUrlOrSlug = (urlOrSlug: string): string | undefined =>  {
    const cleanString = urlOrSlug.split('?')[0].replace(/\/$/, '');
    return cleanString.split('-').pop();
  }

/*
Central adapter for the `slug` from Next's App Router `useParams()`. On the catch-all route
([[...slug]]) useParams() returns the segments as a string[] (or undefined at the locale root).
The URL helpers above (isPdpUrl / getSkuFromUrlOrSlug) expect a string, so convert the slug to a
'/'-joined path string here in one place instead of each caller doing it.
*/
const slugParamToPath = (slug: string | string[] | undefined): string =>
    Array.isArray(slug) ? slug.join('/') : (slug ?? '');

export { isPdpUrl, getPdpUrl, getPdpUrlWithLocale,  getSkuFromUrlOrSlug, slugParamToPath };